import React, {useMemo} from 'react';
import Select from '../Select';
import { format, startOfWeek, endOfWeek, eachWeekOfInterval, add as addDate, sub as subDate } from 'date-fns';

const weekOpts = { weekStartsOn: 1 };

const TheWeek = (props) => {

    const now = new Date();

    const weekOptions = useMemo(() => {
        return eachWeekOfInterval({
            start: startOfWeek(subDate(now, {weeks: 2}), weekOpts),
            end: endOfWeek(addDate(now, {weeks: 8}), weekOpts)
        }).map(week => {
            const key = format(week, 'RRRR-II').replace('-', '-W');
            const normalTitle = format(startOfWeek(week, weekOpts), 'do LLL')+' - '+format(endOfWeek(week, weekOpts), 'do LLL');
            const isThisWeek = key === format(new Date(), 'RRRR-II').replace('-', '-W');

            return {
                label: isThisWeek ? 'This week' : normalTitle,
                value: key,
            };
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options = [
        {value: '', label: props.noWeekSelectedLabel ?? 'Any'},
        ...weekOptions
    ];

    return <>
        <Select {...{options, ...props}} />
    </>
}

export default TheWeek;
